export const DEFAULT_TIMEZONE = 'Etc/UTC';

export function isValidTimezone(timezone: string | undefined): timezone is string {
    if (!timezone) {
        return false;
    }

    if (timezone === DEFAULT_TIMEZONE) {
        return true;
    }

    try {
        if (typeof Intl.supportedValuesOf === 'function') {
            return Intl.supportedValuesOf('timeZone').includes(timezone);
        }
        new Intl.DateTimeFormat('en-US', {timeZone: timezone}).format();
        return true;
    } catch {
        return false;
    }
}

export function getBrowserTimezone(): string {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return isValidTimezone(timezone) ? timezone : DEFAULT_TIMEZONE;
}
